import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, tap } from 'rxjs';
import { UserPreferencesData } from '../models/user-preferences-data';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@feature/store/application-store';
import { selectUserPreferenceState } from '../selectors/user-preferences';
import { State } from '../reducers/user-preferences';
import * as actions from '../actions/user-preferences';

@Injectable()
export class UserPreferencesService {

    private userPreferences = new BehaviorSubject<UserPreferencesData>(null);

  constructor(
    protected store: Store<ApplicationState>) { }

    getUserPreferences(): Observable<UserPreferencesData> {
        return this.store.select(selectUserPreferenceState)
          .pipe(
            tap((userPreferences: State) => {
              if (!userPreferences.loading && !userPreferences.error && !userPreferences.effectiveValues) {
                this.store.dispatch(new actions.LoadEffectiveValues());
              } else {
                this.userPreferences.next(userPreferences.effectiveValues);
              }
            }),
            filter(userPreferences => userPreferences != undefined && !userPreferences.loading),
            map(u => u.effectiveValues)
          );
      }

      loadUserPreferences(): void{
        this.store.dispatch(new actions.LoadEffectiveValues());
      }

}
